"use client"

import { useEffect, useRef, useState, useMemo } from "react"
import { Chart, registerables } from "chart.js"
import usersIcon from "../../assets/icons/usersIcon.svg"
import documentIcon from "../../assets/icons/documentIcon.svg"
import StatCard from "../../components/shared/StatCard"
import AccessManagementTable from '../../components/shared/AccessManagementTable';
import AuditLogsTable from '../../components/shared/AuditLogsTable';
import SubAdminModal from '../../components/shared/subAdminModal';
import DeleteIcon from '../../assets/icons/delete.svg';
import ConfirmationModal from '../../components/modals/confirmationModal';

Chart.register(...registerables)

export default function AdminDashboard() {
 const chartRef = useRef(null)
 const chartInstance = useRef(null)
    const [subAdminModalOpen, setSubAdminModalOpen] = useState(false);
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
    const [isModalEditMode, setIsModalEditMode] = useState(false);
    const [currentSubAdminData, setCurrentSubAdminData] = useState(null);
    const [subAdminToDelete, setSubAdminToDelete] = useState(null);

 // Example: raw monthly data for users and projects
const rawData = useMemo(() => ({
  users: [120, 450, 680, 320, 180, 420, 580, 220, 750, 520, 380, 650],
  projects: [80, 280, 420, 580, 720, 380, 480, 520, 180, 450, 320, 280],
}), []);

 // Convert raw numbers → percentages (relative per-month)
 const userPercentages = rawData.users.map((val) => Math.round((val / 900) * 100)) // 900 = max scale
 const projectPercentages = rawData.projects.map((val) =>
  Math.round((val / 900) * 100)
 )

const chartData = useMemo(() => ({
  labels: [
    "Jan 2019",
    "Feb 2019",
    "Mar 2019",
    "Apr 2019",
    "May 2019",
    "Jun 2019",
    "Jul 2019",
    "Aug 2019",
    "Sep 2019",
    "Oct 2019",
    "Nov 2019",
    "Dec 2019",
  ],
  datasets: [
    {
      label: "Users",
      data: userPercentages,
      rawData: rawData.users, // Add raw data for the tooltip
      backgroundColor: "#F36E49",
      borderWidth: 0,
    },
    {
      label: "Projects",
      data: projectPercentages,
      rawData: rawData.projects, // Add raw data for the tooltip
      backgroundColor: "#8B5CF6",
      borderWidth: 0,
    },
  ],
}), [userPercentages, projectPercentages, rawData]);

useEffect(() => {
  if (chartRef.current) {
    if (chartInstance.current) chartInstance.current.destroy();

    const ctx = chartRef.current.getContext("2d");

    // Plugin for chart background
    const backgroundPlugin = {
      id: "custom_canvas_background_color",
      beforeDraw: (chart) => {
        const { ctx, chartArea } = chart;
        ctx.save();
        ctx.fillStyle = "#F8F2FC80"; // semi-transparent background
        ctx.fillRect(
          chartArea.left,
          chartArea.top,
          chartArea.right - chartArea.left,
          chartArea.bottom - chartArea.top
        );
        ctx.restore();
      },
    };

    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: chartData,
      plugins: [backgroundPlugin],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false, // hide vertical grid lines
            },
            ticks: { color: "#6B7280", font: { size: 12 } },
          },
          y: {
            stacked: true,
            beginAtZero: true,
            max: 100,
            ticks: {
              color: "#6B7280",
              font: { size: 12 },
              stepSize: 25,
              callback: (value) => `${value}%`,
            },
            grid: {
              color: "#E8E8EA",
              borderDash: [4, 4], // dashed horizontal lines
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            mode: "index",
            intersect: false,
            backgroundColor: "#FFFFFF",
            titleColor: "#180A63",
            bodyColor: "#180A63",
            borderColor: "#E8E8EA",
            borderWidth: 1,
            cornerRadius: 8,
            displayColors: true,
            position: "nearest",
            callbacks: {
              title: (context) => context[0].label,
              label: (context) => {
                const datasetIndex = context.datasetIndex;
                const dataIndex = context.dataIndex;
                const rawValue = chartData.datasets[datasetIndex].rawData[dataIndex];
                return `${context.dataset.label}: ${rawValue}`;
              },
            },
          },
        },
        interaction: {
          mode: "index",
          intersect: false,
        },
      },
    });
  }

  return () => {
    if (chartInstance.current) chartInstance.current.destroy();
  };
}, [chartData]);

	const accessUsers = [
		{ name: 'Majid Ali', email: 'majidali@nesl-it.com', role: 'Sub-admin', status: 'ACTIVE' },
		{
			name: 'Haseeb Ahmed',
			email: 'muhammadhaseeb@nesl-it.com',
			role: 'Sub-admin',
			status: 'ACTIVE'
		},
		{ name: 'Zunair Khan', email: 'zunairkhan@nesl-it.com', role: 'Sub-admin', status: 'IN-ACTIVE' }
	];

	const auditLogs = [
		{
			activity: 'Logged in',
			comment: 'Logged into the sub-admin',
			email: 'majidali@nesl-it.com',
			datetime: '01 July, 2025 - 14:30'
		},
		{
			activity: 'Resolve query',
			comment: 'Resolved query #0981',
			email: 'muhammadhaseeb@nesl-it.com',
			datetime: '04 July, 2025 - 09:23'
		}
	];

	const handleDelete = () => {
		//API Logic for delete
		setDeleteConfirmationModalOpen(false);
	};

	const handleEditSubAdmin = (user) => {
		setSubAdminModalOpen(true);
		setIsModalEditMode(true);
		setCurrentSubAdminData(user);
	};

	const handleDeleteSubAdmin = (user) => {
		setDeleteConfirmationModalOpen(true);
		setSubAdminToDelete(user);
	};

  return (
    <div className="">
      {/* Header Section */}
        <div className="flex flex-col items-center md:flex-row md:justify-between md:items-center gap-4 mb-10 md:mb-[50px]">

        <h1 className="text-2xl sm:text-3xl font-semibold text-dark-blue text-center md:text-left">
            Welcome, Bridgette
        </h1>

        <button
            className="inline-flex items-center space-x-2 bg-dark-blue max-w-[210px] h-[52px] py-5 px-4 text-base font-semibold leading-100 text-white rounded-md cursor-pointer"
            onClick={() => {
            setSubAdminModalOpen(true)
            setIsModalEditMode(false)
            setCurrentSubAdminData(null)
            }}
        >
            <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
                d="M6.5625 0.875C6.5625 0.391016 6.17148 0 5.6875 0C5.20352 0 4.8125 0.391016 4.8125 0.875V4.8125H0.875C0.391016 4.8125 0 5.20352 0 5.6875C0 6.17148 0.391016 6.5625 0.875 6.5625H4.8125V10.5C4.8125 10.984 5.20352 11.375 5.6875 11.375C6.17148 11.375 6.5625 10.984 6.5625 10.5V6.5625H10.5C10.984 6.5625 11.375 6.17148 11.375 5.6875C11.375 5.20352 10.984 4.8125 10.5 4.8125H6.5625V0.875Z"
                fill="white"
            />
            </svg>
            <span>Add new sub-admin</span>
        </button>
        </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-10 md:mb-[50px]">
        <StatCard 
          icon={usersIcon}
          bgColor="bg-lightGrey"
          textColor="text-dark-blue"
          label="Total register users"
          value="28,891"
          newValue="5,541"
        />
        <StatCard 
          icon={usersIcon}
          bgColor="bg-lightGrey"
          textColor="text-green-600"
          label="Active paid users"
          value="8,901"
          newValue="281"
        />
        <StatCard 
          icon={documentIcon}
          bgColor="bg-lightGrey"
          textColor="text-purple-600"
          label="Total projects"
          value="41,900"
          newValue="14,543"
        />
      </div>

      {/* Chart */}
      <div className="bg-white rounded-xl p-6 shadow-sm border-2 border-lightGrey mb-10 md:mb-[50px]">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-dark-blue">Usage chart</h2>
          <select className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm text-dark-blue focus:outline-none focus:ring-2 focus:ring-dark-blue focus:border-transparent">
            <option value="monthly">Monthly</option>
            <option value="weekly">Weekly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div className="h-80">
          <canvas ref={chartRef}></canvas>
        </div>
      </div>
      			<div className="flex justify-between flex-col md:flex-row items-center mb-12">
				<div>
					<h1 className="text-[22px] font-medium text-dark-blue">
						Access Management
					</h1>
				</div>

				<div>
				<a
					href="access-management"
					className="inline-flex items-center gap-2 text-dark-blue text-20 underline leading-24"
				>
					View all
				</a>
				</div>
			</div>
        <AccessManagementTable
            accessUsers={accessUsers}
            onEditSubAdmin={handleEditSubAdmin}
            onDeleteSubAdmin={handleDeleteSubAdmin}
        />

        <AuditLogsTable heading={"Audit logs"} auditLogs={auditLogs} />
        			<SubAdminModal
				isOpen={subAdminModalOpen}
				onClose={() => setSubAdminModalOpen(false)}
				isEdit={isModalEditMode}
				initialFirstName={currentSubAdminData?.name.split(' ')[0]}
				initialLastName={currentSubAdminData?.name.split(' ')[1]}
				initialEmail={currentSubAdminData?.email}
			/>

			<ConfirmationModal
				isOpen={deleteConfirmationModalOpen}
				onClose={() => setDeleteConfirmationModalOpen(false)}
				icon={<img src={DeleteIcon} alt="Delete" className="mx-auto" />}
				heading="Deleting sub-admin"
				description={
					<>
						Are you sure you want to delete{' '}
						<span className="text-dark-blue font-medium">{subAdminToDelete?.name}</span> from
						sub-admins?
					</>
				}
				primaryButtonText="Cancel"
				secondaryButtonText="Delete"
				onPrimaryClick={() => setDeleteConfirmationModalOpen(false)}
				onSecondaryClick={handleDelete}
			/>
    </div>
  )
}
